import { render } from "./default.vue?vue&type=template&id=97c914b6"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"

import "./default.vue?vue&type=style&index=0&id=97c914b6&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/videos/_components/default.vue'],['render',render],['__file',"default.vue"]])

export default __exports__